import api from './index'
import { axios } from '@/utils/request'

export function createVocabulary(parameter) {
  return axios({
    url: api.BaseURL + api.Vocabulary + 'create',
    method: 'POST',
    data: parameter
  })
}

export function getListVocabulary(parameter) {
  return axios({
    url: api.BaseURL + api.Vocabulary + 'list',
    method: 'GET',
    params: parameter
  })
}

export function getDetailVocabulary(parameter) {
  return axios({
    url: api.BaseURL + api.Vocabulary + 'detail',
    method: 'GET',
    params: parameter
  })
}

export function updateVocabulary(parameter) {
  return axios({
    url: api.BaseURL + api.Vocabulary + 'update_self_study',
    method: 'POST',
    data: parameter
  })
}

export function deleteVocabulary(parameter) {
  return axios({
    url: api.BaseURL + api.Vocabulary + 'delete',
    method: 'POST',
    data: parameter
  })
}

export function createVocabularyForConversation(parameter) {
  return axios({
    url: api.BaseURL + api.Vocabulary + 'conversation',
    method: 'POST',
    data: parameter
  })
}

export function createVocabularyForExpression(parameter) {
  return axios({
    url: api.BaseURL + api.Vocabulary + 'expression',
    method: 'POST',
    data: parameter
  })
}